export type SearchAIIconProps = {
  width?: number;
  height?: number;
  className?: string;
  title?: string;
  titleId?: string;
};

export const SearchAIIcon = ({
  width = 18,
  height = 18,
  title = "Ícone de busca IA",
  titleId,
  className,
}: SearchAIIconProps) => {
  const id = "search-ai-linear-gradient";
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
    >
      <title id={titleId}>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 7.058C2 4.269 4.269 2 7.058 2C9.846 2 12.115 4.269 12.115 7.058C12.115 9.847 9.846 12.115 7.058 12.115C4.269 12.115 2 9.847 2 7.058ZM17.207 15.793L12.697 11.283C13.583 10.103 14.115 8.643 14.115 7.058C14.115 3.166 10.949 0 7.058 0C3.166 0 0 3.166 0 7.058C0 10.949 3.166 14.115 7.058 14.115C8.643 14.115 10.103 13.583 11.283 12.697L15.793 17.207C15.988 17.403 16.244 17.5 16.5 17.5C16.756 17.5 17.012 17.403 17.207 17.207C17.598 16.817 17.598 16.184 17.207 15.793Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          id={id}
          x1="0"
          y1="8.75"
          x2="17.5003"
          y2="8.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E22446" />
          <stop offset="1" stopColor="#5858BF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
